import actionIds from '../constants/action-ids';
import { t } from '../../localization';
import configStorage from '../../configuration/config-storage';
import yoproductsServiceClient from '../../common/helpers/yoproducts-service-client';

const getRenewDate = () => {
  const { locale = 'en' } = configStorage.get();
  const renewDate = new Date();
  renewDate.setDate(new Date().getDate() + 14);
  return renewDate.toLocaleDateString(locale, { month: 'long', day: 'numeric' });
};

const getStepLineItems = ({ domainName, actionId, currency }) => {
  const { locale = 'en' } = configStorage.get();
  const yoproducts = yoproductsServiceClient.get();

  const renewDate = getRenewDate();
  const formattedPrice = yoproducts.actions.formatPrice(0.0, locale, currency, {
    leadingCurrency: true,
  });

  let firstStepDescription;

  switch (actionId) {
    case actionIds.BUY_DOMAIN: {
      const markedDomain = `<span 
        class="ws-ui-text ws-ui-text--inherit ws-ui-text--accent ws-ui-text--align-left ws-ui-text--mark ws-ui-text--weight-medium"
      >
        ${domainName}
      </span>`;
      firstStepDescription = t(
        'Build and launch a website on your custom domain. Pay only for {domainName} today.',
        { domainName: markedDomain }
      );
      break;
    }
    case actionIds.THIRD_PARTY_DOMAIN:
      firstStepDescription = t(
        'Build and launch a website on your domain purchased elsewhere — <b>{price} due today.</b>',
        { price: formattedPrice }
      );
      break;
    case actionIds.GET_FREE_DOMAIN:
    default:
      firstStepDescription = t(
        'Build and launch your Ads-free website with professional templates, AI tools and 24/7 customer support.'
      );
      break;
  }

  return [
    {
      id: 'step-1',
      title: t('Publish today'),
      description: firstStepDescription,
      isActive: true,
    },
    {
      id: 'step-2',
      title: t('Starting on {renewDate}', { renewDate }),
      description: t(
        'Your website plan auto-renews. We’ll remind you 4 days before. Cancel anytime.'
      ),
      isActive: false,
    },
  ];
};

export default getStepLineItems;
